import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const PayDueAppsRaw = React.lazy(() => import(/* webpackChunkName: "AdminPayDueApps" */ './PayDueApps'));
export const PayDueAppearances = () => (React.createElement(Page, { title: "Payment Due Appearances", description: "Payment Due Appearances" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(PayDueAppsRaw, null)))));
